module.exports = __webpack_public_path__ + "img/2.fde038f3.webp";